import defaultConfig, { LEFT, RIGHT } from '../default/config_default';
import { cloneDeep } from 'lodash';

let page = cloneDeep(defaultConfig);

page.imageSrc = 'background/strona_026.jpg';
page.paint = [
  {
    id: 'page013_game3',
    icon: 'ikona_cw3',
    // tooltip: "Zaprogramuj animację (Scratch).",
    // tooltip: "page000_test24 TrInputOnBackgroundJims08",
    paintObj: {
      text: 'Pokoloruj i udekoruj bombki.  ',
      audio: 'files/page013/z13c3.mp3',
      item: {
        path: 'informatyka/files/page013/z.13cw.3.bmp',
      },
      cssStyle: {
        width: '765px !important',
      },
    },
    pos: {
      x: LEFT,
      y: 400,
    },
  },
  {
    id: 'page013_game2',
    icon: 'ikona_cw2',
    // tooltip: "Zaprogramuj animację (Scratch).",
    // tooltip: "page000_test24 TrInputOnBackgroundJims08",
    paintObj: {
      text: 'Dokończ rysunek.  ',
      audio: 'files/page013/z13c2.mp3',
      item: {
        path: 'informatyka/files/page013/z.13cw.2.bmp',
      },
      cssStyle: {
        width: '765px !important',
      },
    },
    pos: {
      x: LEFT,
      y: 200,
    },
  },
  {
    id: 'page013_game1',
    icon: 'ikona_cw1',
    // tooltip: "Zaprogramuj animację (Scratch).",
    // tooltip: "page000_test24 TrInputOnBackgroundJims08",
    paintObj: {
      text: 'Pokoloruj bombki na choince, a potem oprósz ją śniegiem.  ',
      audio: 'files/page013/z13c1.mp3',
      item: {
        path: 'informatyka/files/page013/z.13cw.1.bmp',
      },
      cssStyle: {
        width: '765px !important',
      },
    },
    pos: {
      x: LEFT,
      y: 0,
    },
  },
];
page.images = [
  {
    imageId: 'page026_zoom0',
    rectangle: {
      x: 123,
      y: 309,
      width: 1676,
      height: 936,
    },
    imageSrc: 'images/page026/026 2.jpg',
  },
  {
    imageId: 'page026_zoom1',
    rectangle: {
      x: 610,
      y: 1542,
      width: 1164,
      height: 920,
    },
    imageSrc: 'images/page026/026 1.jpg',
  },
];
page.games = [
  {
    id: 'page013_game4',
    tooltip: '',
    icon: 'ikona_cw4',
    pos: {
      x: LEFT,
      y: 600,
    },
  },
  {
    id: 'page026_game10',
    icon: 'ikonaStepbystep',

    pos: {
      x: LEFT,
      y: 1515,
    },
    item: {
      id: 'page026_game10',
    },
    rectangle: {
      id: 'page026_rect0',
    },
  },
];
page.rectangle = [
  {
    id: 'page026_rect0',

    tooltip: '',

    linked: ['page026_game10'],
    x: 120,
    y: 1515,
    width: 463,
    height: 920,
  },
];
export default page;
